module.exports = __webpack_public_path__ + "img/74cdb54.png";